//Library Imports
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";

//Local Imports
import Checkbox from "../../Common/Components/Checkbox";
import { RootState } from "store";
import { updateFilterInStore } from "../actions";
import { filtersList } from "../utils";
import { capitalizeFirstLetter } from "utils";

interface ICampaignList {
  setIsFiltered: (value: boolean) => void;
}

const CampaignList: React.FC<ICampaignList> = (props: ICampaignList) => {
  // Props
  const { setIsFiltered } = props;

  // Redux States
  const emailsLoading: boolean = useSelector((state: RootState) => state.automation.emails.loading);

  // Local Variables
  const defaultCheckboxStates = {
    allTypes: false,
    adhoc: false,
    digest: false,
  };

  // Local States
  const [checkboxStatesObj, setCheckboxStatesObj] = useState<any>(defaultCheckboxStates);

  // Component Logic
  useEffect(() => {
    setCheckboxStatesObj({
      ...defaultCheckboxStates,
      allTypes: true,
    });
    updateFilterInStore("allTypes");
  }, []);

  const filterHandler = (checked: boolean, value: string) => {
    if (checked) {
      setCheckboxStatesObj({
        ...defaultCheckboxStates,
        [value]: true,
      });
      updateFilterInStore(value);
      if (value === "allTypes") setIsFiltered(false);
      else setIsFiltered(true);
    }
  };

  return (
    <Wrapper>
      <div className="label-container">Email / Campaigns selected</div>
      <ul className={`${emailsLoading ? "disabled" : ""}`}>
        <li>
          <div className="group-label">Filter Emails</div>
        </li>
        {filtersList.map((filterValue: string) => (
          <li>
            <label>
              <Checkbox
                checked={checkboxStatesObj[filterValue]}
                onChange={(e: any) => filterHandler(e.target.checked, filterValue)}
              />
              <span>{filterValue === "allTypes" ? "All Types" : capitalizeFirstLetter(filterValue)}</span>
            </label>
          </li>
        ))}
      </ul>
    </Wrapper>
  );
};

export default CampaignList;

const Wrapper = styled.div`
  .disabled {
    opacity: 0.5;
    pointer-events: none;
  }
  .label-container {
    color: #424b50;
    font-size: 16px;
    font-weight: 500;
    font-family: "Roboto", sans-serif;
    padding: 28px 0 10px 16px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 14px;
    }
  }
  ul {
    margin: 0 0 0 16px;
    padding: 0;
    list-style: none;
    li {
      margin: 10px 0;
      padding: 0;
      .group-label {
        font-size: 14px;
        font-weight: 500;
        font-family: "Roboto", sans-serif;
        line-height: 20px;
        color: #424b50;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 12px;
        }
      }
      span {
        color: #67696a;
        font-size: 16px;
        font-weight: 500;
        font-family: "Roboto", sans-serif;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 14px;
        }
      }
    }
  }
`;
